'use client';

import { useSession } from 'hooks/useSession';
import { BaseSheetRenderer } from 'store/sheet-store';

/**
 * Thin wrapper around the sheet-store's `BaseSheetRenderer` that injects the
 * session's `isLoggedIn` state. The renderer uses this to gate the URL-
 * deep-link auto-open logic so sheets don't open before auth completes.
 */
export default function SheetRenderer() {
  const { isLoggedIn } = useSession();
  return <BaseSheetRenderer isLoggedIn={isLoggedIn} />;
}
